module.exports = __webpack_public_path__ + "static/media/procesos11.8ac07dc6.jpg";